export * from './userpermission.component';


// WEBPACK FOOTER //
// ./src/app/landingpages/userpermission/index.ts